 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import ABOUT_THIS_BOOK from '@/components/About_This_Book'
 import ABOUT_THE_AUTHOR from '@/components/About_the_Author'
 import TITLE_PAGE from '@/components/Title_Page'
 import COPYRIGHT from '@/components/Copyright'
 import CONTENTS from '@/components/Contents'
 import THE_BLESSING_PRAYER from '@/components/The_Blessing_Prayer'
 import HOW_TO_USE_THIS_BOOK from '@/components/How_to_Use_This_Book'
 import WORDS_FROM_THE_OLD_ONES from '@/components/Words_From_the_Old_Ones'
 import CALLING_THE_GOD_AND_GODDESS from '@/components/Calling_the_God_and_Goddess'
 import CREATING_SACRED_SPACE from '@/components/Creating_Sacred_Space'
 import THE_SABBATS from '@/components/The_Sabbats'
 import FULL_MOON_RITES from '@/components/Full_Moon_Rites'
 import PRAYERS_CHANTS_AND_INVOCATIONS from '@/components/Prayers_Chants_and_Invocations'
 import RITES_AND_LORE from '@/components/Rites_and_Lore'
 import RECIPES_FOR_THE_FEAST from '@/components/Recipes_for_the_Feast'
 import AN_HERBAL_GRIMOIRE from '@/components/An_Herbal_Grimoire'
 import HERBAL_RECIPES_AND_SECRETS from '@/components/Herbal_Recipes_and_Secrets'
 import INCENSES from '@/components/Incenses'
 import OILS from '@/components/Oils'
 import MAGICAL_LORE_SPELLS_AND_RITUALS from '@/components/Magical_Lore_Spells_and_Rituals'
 import SYSTEMS_OF_POWER from '@/components/Systems_of_Power'
 import RUNE_MAGIC from '@/components/Rune_Magic'
 import SIGNS_AND_SYMBOLS from '@/components/Signs_and_Symbols'
 import BIBLIOGRAPHY from '@/components/Bibliography'
 import APPENDIX_I from '@/components/Appendix_I'
 import APPENDIX_II from '@/components/Appendix_II'
 import APPENDIX_III from '@/components/Appendix_III'
 import APPENDIX_IV from '@/components/Appendix_IV'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Cover",
 			"name" : "Cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/About_This_Book",
 			"name" : "About_This_Book",
 			"component" : ABOUT_THIS_BOOK
 		},
 		{
 			"path" : "/About_the_Author",
 			"name" : "About_the_Author",
 			"component" : ABOUT_THE_AUTHOR
 		},
 		{
 			"path" : "/Title_Page",
 			"name" : "Title_Page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/Copyright",
 			"name" : "Copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/The_Blessing_Prayer",
 			"name" : "The_Blessing_Prayer",
 			"component" : THE_BLESSING_PRAYER
 		},
 		{
 			"path" : "/How_to_Use_This_Book",
 			"name" : "How_to_Use_This_Book",
 			"component" : HOW_TO_USE_THIS_BOOK
 		},
 		{
 			"path" : "/Words_From_the_Old_Ones",
 			"name" : "Words_From_the_Old_Ones",
 			"component" : WORDS_FROM_THE_OLD_ONES
 		},
 		{
 			"path" : "/Calling_the_God_and_Goddess",
 			"name" : "Calling_the_God_and_Goddess",
 			"component" : CALLING_THE_GOD_AND_GODDESS
 		},
 		{
 			"path" : "/Creating_Sacred_Space",
 			"name" : "Creating_Sacred_Space",
 			"component" : CREATING_SACRED_SPACE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js